import React, { Component } from 'react';
import cx from 'classnames';

import mask from 'assets/img/maska.png';
import EntryForm from '../components/EntryForm';
import Button from 'base/components/Button';
import API from 'base/api';

const infos = {
  VALIDATION_FAILED: 'Wprowadzono niepoprawne dane.',
  GOOD: 'Gratulacje! Zapisałeś się na Bal. Skontaktujemy się z Tobą w najbliższym czasie. ',
  DB_ERROR: 'Błąd połączenia z bazą danych. Spróbuj ponownie za chwilę...',
  ALREADY_EXIST: 'Mamy już takie zgłoszenie.',
  DEFAULT_ERROR: 'Coś poszło nie tak.'
}

const Info = (props) => {
  const styles = cx('entry-form-info', {
    'entry-form-info--error': props.isError
  });

  return (
    <div>
      <p className={styles}>
        {props.info}
      </p>
      <Button style={{'margin':'0 auto'}} onClick={props.onBack}>Wróć</Button>
    </div>
  );
};

export default class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
      response: null,
      isError: true,
      readOnly : false
    }
  }

  handleSubmit = (values) => {
    this.setState({sending: true});

    const data = this.parseValues(values);

    fetch(API.ADD, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => res.json())
    .then(response => {
      // console.log('success:', response);
      let info = response.info;
      let isError = true;
      switch(response.code) {
        case '001':
          info = infos.VALIDATION_FAILED;
          break;
        case '002':
          info = infos.GOOD;
          isError = false;
          break;
        case '003':
          info = infos.DB_ERROR;
          break;
        case '005':
          info = infos.ALREADY_EXIST;
          break;
        default:
          info = infos.DEFAULT_ERROR;
          break;
      }
      this.setState({
        response: info,
        isError: isError,
        sending: false,
        readOnly: false

      });
    })
    .catch( error => {
      this.setState({
        response: infos.DB_ERROR,
        isError: true,
        sending: false,
        readOnly: false
      });
    });
  }

  parseValues = (values) => {
    // let icePerson = ["", ""];
    // if(values.icePerson)
    //   icePerson = values.icePerson.split(' ').filter( e => e);
    // const department = values.department !== 'w0' ? values.department : values.otherDepartment;

    const output = {
      firstName: values.name,
      surname: values.surname,
      index: values.index,
      mail: values.mail,
      phoneNumber: values.phoneNumber,
      isIzet: values.izet,
      diet: values.diet,
      isPartner: values.partner,
      partner: {
        firstName: values.partnerName || '',
        surname: values.partnerSurname || '',
        mail: values.partnerMail || '',
        isIzet: values.partnerIzet || '',
        diet: values.partnerDiet || '',
      },
      // tShirtSize: values.shirtSize,
      // department: department,
      // sex: values.sex,
      // transport: values.transportHour === 0 ? 'wlasny' : values.transportHour,
      // ice: values.iceNumber,
      // icePerson: values.icePerson,
    };

    return output;
  }

  handleBack = (e) => {
    const {isError} = this.state
    this.setState({
      response: null,
      isError: false,
      readOnly: !isError
    })
  }

  render() {
    const { sending, response, isError, readOnly } = this.state;

    return (
      <div className="entryform-body">
        <div className="entryform-container">
          {/* <div className="entryform-logo" /> */}
          <img className="entryform-img" src={mask} alt="" />
          <h1 className="entryform-header">8 Twarzy IZETU</h1>
          <p className="entryform-subheader">Bal Maskowy</p>
        </div>
        {/* <p className="form-description" style={{ display: `${response ? 'none' : 'block'}`}}>
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, textAlign: 'left' }}>
            Dla przypomnienia:<br /><br />
            <li>kiedy? 25 - 27.10.2019r.</li>
            <li>gdzie? Ośrodek 'Złoty Potok' Pokrzywna</li>
            <li>cena? 175 zł</li>
          </ul>
        </p> */}
        <div className="entryform-container">
            {
              <EntryForm onSubmit={this.handleSubmit}
                isSubmitting={sending}
                hidden={ response ? true : false }
                readOnly={readOnly} />
            }
            {
              response &&
                <Info info={response} isError={isError} onBack={this.handleBack} />
            }
        </div>
        <p className="promo-text">Aplikację do obsługi wydarzeń rozwija <a href="http://nativeflow.napwr.pl">KN Native Flow</a></p>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/views/User.js